const filtrosIniciais = () => ({
  nome: '',
  apelido: '',
  grupo: '',
  page: 1,
  pageSize: 25
});

export default {
  data() {
    return {
      filters: filtrosIniciais()
    };
  },
  
  methods: {
    /**
     * Limpa todos os filtros e retorna aos valores iniciais
     */
    limparFiltros() {
      this.filters = filtrosIniciais();
      this.centrosCustosResponse = {
        centrosCustos: [],
        total: 0,
        page: 1
      };
    },
    
    atualizarFiltros(novosFiltros) {
      this.filters = { ...this.filters, ...novosFiltros };
    },
    
    alterarPaginacao(novosFiltros) {
      this.atualizarFiltros(novosFiltros);
      this.pesquisarCentrosCustos();
    }
  }
};

